import { html } from 'lit-html';
import { RrAreaNormal } from '../../../../core/views/pc/rr_item/rr_area_normal';
import { CommonErrorJsEnv } from '../../models/common_error_js_env';

export const RrBodyCommonError2 = (model: CommonErrorJsEnv) => html`
${RrAreaNormal(model.rrAreaProfileCommonError2, model.isLogin)}
`;

export const RrBodyCommonError3 = (model: CommonErrorJsEnv) => html`
${RrAreaNormal(model.rrAreaProfileCommonError3, model.isLogin)}
`;
